angular.module('components.media.AudioService', [
  'global'
])

/**
 * The AudioService service handles scoring and
 * feedback for the state.contentView type
 *
 * @class AudioService
 * @constructor
 * @module components.media.AudioService
 */
.factory('AudioService', [
  function () {
    'use strict';

    var service = {

    };

    return service;
  }
]);
